import React from 'react';
import PropTypes from 'prop-types';

import RadioButtonComponent from './Component';

const RadioButtonContainer = ({ input, children, labelClassName, disabled }) => (
  <RadioButtonComponent {...input} labelClassName={labelClassName} disabled={disabled}>
    {children}
  </RadioButtonComponent>
);

RadioButtonContainer.propTypes = {
  input: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,

  labelClassName: PropTypes.string,
  disabled: PropTypes.bool
};

RadioButtonContainer.defaultProps = {
  labelClassName: ''
};

export { RadioButtonContainer as ReduxFormWrapper };
